<template>
  <cta
    :to="to"
    :href="href"
    :text="text"
    variant="solid"
    :color="ctaColor"
    :show-icon="true"
    @click="$emit('click')"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false">
    <template #icon>
      <div class="icon-wrapper">
        <div class="icon-absolute">
          <img
            :src="iconUrl"
            class="store-icon"
            :class="{ 'store-icon--hover': colorChange && isHovered }"
            alt="" />
        </div>
      </div>
    </template>
  </cta>
</template>

<script setup>
  import { computed, ref } from 'vue'

  import Cta from '~/components/Cta.vue'
  import {
    getStoreIconUrlMinimal, getStoreType, STORE_TYPE
  } from '~/utils/stores'

  const isHovered = ref(false)

  const props = defineProps({
    store: {
      type: Object,
      required: true
    },
    to: String,
    href: String,
    text: {
      type: String,
      required: true
    },
    colorChange: {
      type: Boolean,
      required: false,
      default: false
    },
    color: {
      type: String,
      required: false,
      default: 'red'
    },
    colorHover: {
      type: String,
      required: false,
      default: 'white'
    }
  })

  defineEmits([ 'click' ])

  const ctaColor = computed(() => {
    return getStoreType(props.store) === STORE_TYPE.MONOBRAND ? props.color : 'black'
  })

  const iconUrl = computed(() => getStoreIconUrlMinimal(props.store))
</script>

<style lang="scss" scoped>
.icon-wrapper {
  height: 0;
  width: 28px;
  position: relative;

  .icon-absolute {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    width: 28px;
  }

  .store-icon {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    transition: filter var(--timing-fast) var(--easing-default);

    &--hover {
      filter: brightness(0) saturate(100%) invert(1);
    }
  }
}
</style>
